import { TextField } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { bankSchema } from "../../utils/validationSchemas";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { getkycDetailsApi } from "../../redux/features/kycDetailsSlice";
import LoadingButton from "@mui/lab/LoadingButton";
import { FaSave } from "react-icons/fa";
import { decryptFields, encryptFields } from "../../utils/kycStatus";
import axiosInstance from "../../utils/axiosInstance";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { stringSimilarity } from "string-similarity-js";

const fields = [
  { id: "name", label: "Account Holder's Name" },
  { id: "accountNum", label: "Bank Account Number" },
  { id: "ifsc", label: "Bank IFSC Code" },
];

export default function Bank({ kycDetailApiResponse }) {
  const { name, account_no, ifsc } = kycDetailApiResponse?.[0]?.bank?.msg || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { values, handleSubmit, handleChange, errors, setValues } = useFormik({
    initialValues: {
      name: "",
      accountNum: "",
      ifsc: "",
    },
    validationSchema: bankSchema,
    validateOnMount: false,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: async () => {
      await bankKycVerify();
    },
  });

  const [bankDetail, setBankDetail] = useState("");

  const bankKycVerify = async () => {
    try {
      const response = await axios.get(
        `https://ifsc.razorpay.com/${values.ifsc}`
      );

      if (response.status === 200) {
        setBankDetail(response.data);
        bankKycVerify2();
      }

      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        Swal.fire({
          icon: "error",
          title: "Invalid IFSC code",
          text: "Invalid IFSC code.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Invalid Details",
          text: "Invalid Account number or IFSC code.",
        });
      }
      console.error("Error fetching bank details:", error);
      throw error;
    }
  };

  const [bankVerifyLoading, setBankVerifyLoading] = useState(false);
  // const bankKycVerify2 = async () => {
  //   try {
  //     let parsedData = "";
  //     // if (values.accountNum == "1234567890") {
  //     //   parsedData = {
  //     //     msg: {
  //     //       description: "Success",
  //     //       name: "TEST TEST",
  //     //       status: "Verified",
  //     //       // transID: "1437810291",
  //     //       // tsTransID: "TS-FZE-487327",
  //     //     },
  //     //     status: 1,
  //     //   };
  //     // } else {
  //     setBankVerifyLoading(true);
  //     const response = await axiosInstance.post("/augmont/bankVerify", {
  //       BankAccount: values.accountNum,
  //       ifsc: values.ifsc,
  //     });
  //     parsedData = JSON.parse(response.data.data[0]);
  //     // }

  //     if (parsedData.status === 0) {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Invalid Details",
  //         text:
  //           parsedData?.msg?.status || "Invalid Account number or IFSC code.",
  //       });
  //       return;
  //     }

  //     console.log("parsed Data============>>>", parsedData);
  //     const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
  //     console.log("userDetails==================>>>", userDetails);

  //     if (
  //       parsedData?.msg?.name &&
  //       userDetails?.name &&
  //       parsedData.msg.name.trim().toLowerCase() ===
  //         userDetails.name.trim().toLowerCase()
  //     ) {
  //       await saveBankApi(parsedData);
  //     } else {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Name Mismatch",
  //         text: "The bank account holder’s name must exactly match the PAN card name.",
  //       });
  //     }
  //   } catch (error) {
  //     if (error.response?.status === 404) {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Invalid IFSC code",
  //         text: "Invalid IFSC code.",
  //       });
  //     } else {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Invalid Details",
  //         text: "Invalid Account number or IFSC code.",
  //       });
  //     }
  //     console.error("Error fetching bank details:", error);
  //     throw error;
  //   } finally {
  //     setBankVerifyLoading(false);
  //   }
  // };

  const bankKycVerify2 = async () => {
    try {
      let parsedData = "";
      setBankVerifyLoading(true);

      const response = await axiosInstance.post("/augmont/bankVerify", {
        BankAccount: values.accountNum,
        ifsc: values.ifsc,
      });

      parsedData = JSON.parse(response.data.data[0]);

      if (parsedData.status === 0) {
        Swal.fire({
          icon: "error",
          title: "Invalid Details",
          text:
            parsedData?.msg?.status || "Invalid Account number or IFSC code.",
        });
        return;
      }

      // console.log("parsed Data============>>>", parsedData);
      const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
      // console.log("userDetails==================>>>", userDetails);

      const panName = userDetails?.name || "";
      const bankName = parsedData?.msg?.name || "";

      // 🧹 Normalize both names
      const normalize = (str) =>
        str
          .toLowerCase()
          .replace(/\b(mr|mrs|ms|shri|smt)\b/g, "") // remove common prefixes
          .replace(/[^a-z\s]/g, "") // keep alphabets only
          .replace(/\s+/g, " ") // remove extra spaces
          .trim();

      const cleanPanName = normalize(panName);
      const cleanBankName = normalize(bankName);

      // 🎯 Calculate similarity (value between 0 and 1)
      const similarity = stringSimilarity(cleanPanName, cleanBankName);
      console.log(`🔹 Name similarity: ${similarity}`);

      // Convert to %
      const similarityPercent = (similarity * 100).toFixed(2);

      // 🖨️ Log the result
      console.log(`✅ Name Match Similarity: ${similarityPercent}%`);
      console.log(`PAN Name: ${panName}`);
      console.log(`Bank Name: ${bankName}`);

      if (similarity >= 0.75) {
        await saveBankApi(parsedData);
      } else {
        Swal.fire({
          icon: "error",
          title: "Name Mismatch",
          html: `
            <p>The bank account holder’s name does not match the PAN name.</p>
            `,
            // <p><b>PAN Name:</b> ${userDetails?.name}</p>
            // <p><b>Bank Name:</b> ${parsedData?.msg?.name}</p>
            // <p>Similarity: ${(similarity * 100).toFixed(1)}%</p>
        });
      }
    } catch (error) {
      if (error.response?.status === 404) {
        Swal.fire({
          icon: "error",
          title: "Invalid IFSC code",
          text: "Invalid IFSC code.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Invalid Details",
          text: "Invalid Account number or IFSC code.",
        });
      }
      console.error("Error fetching bank details:", error);
      throw error;
    } finally {
      setBankVerifyLoading(false);
    }
  };

  const saveBankApi = async (parsedData) => {
    const url = `/kyc/bank`;
    try {
      const requestBody = {
        msg: {
          ...parsedData.msg,
          account_no: values.accountNum,
          Bankname: bankDetail.BANK,
          Branchname: bankDetail.BRANCH,
          ifsc: values.ifsc,
        },
        status: parsedData.status,
      };

      const response = await axiosInstance.post(url, requestBody);
      if (!response.error) {
        let userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};

        userDetails = decryptFields(userDetails, ["bank"]);
        userDetails.bank = true;
        userDetails = encryptFields(userDetails, ["bank"]);
        localStorage.setItem("userDetails", JSON.stringify(userDetails));
        dispatch(getkycDetailsApi());
        Swal.fire({
          icon: "success",
          title: "KYC Completed",
          text: "You have successfully completed your KYC. You can now proceed with your gold and silver buying journey.",
        }).then(() => {
          navigate(-2);
        });
        // toast.success("Bank Details saved");
      } else {
        toast.error(
          `Error: ${response.data.message} || "Failed to save bank details"`
        );
      }
    } catch (error) {
      console.log("ERROR IN CATCH+++++++++++++++", error);
    }
  };

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
    const storedName = userDetails.name || "";

    if (account_no) {
      setValues({
        name: storedName,
        accountNum: account_no || "",
        ifsc: ifsc || "",
      });
    } else {
      setValues((prevValues) => ({
        ...prevValues,
        name: storedName,
      }));
    }
  }, [kycDetailApiResponse, account_no]);

  return (
    <div>
      <form
        onSubmit={handleSubmit}
        style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}
      >
        {fields.map(({ id, label }) => (
          <TextField
            key={id}
            id={id}
            label={label}
            variant="outlined"
            size="small"
            onChange={(e) => {
              const value = e.target.value;

              if (id === "accountNum") {
                // Allow only numbers and ensure length <= 18
                if (/^\d{0,18}$/.test(value)) {
                  handleChange(e); // Update state if valid
                }
              } else if (id === "ifsc") {
                if (/^[A-Za-z0-9]{0,11}$/.test(value)) {
                  handleChange(e);
                }
              } else {
                handleChange(e);
              }
            }}
            value={values[id] || ""}
            error={Boolean(errors[id])}
            helperText={errors[id] || ""}
            InputProps={{
              readOnly: !!account_no,
            }}
            sx={{ marginBottom: 2 }}
          />
        ))}

        {!account_no && (
          <div style={{ display: "flex", justifyContent: "end", gap: "1rem" }}>
            <LoadingButton
              type="submit"
              size="small"
              loading={bankVerifyLoading}
              loadingPosition="start"
              startIcon={<FaSave color="white" />}
              variant="contained"
              sx={{
                backgroundColor: "#DA2128",
                color: "white",
                "&:hover": {
                  backgroundColor: "#DA2128",
                },
              }}
            >
              Save
            </LoadingButton>
          </div>
        )}
      </form>
    </div>
  );
}
